<template>
	<Modal
		class="customColumnModal"
		title="自定义列"
		:visible="visible"
		@cancel="cancel"
		width="840px"
	>
		<el-row :gutter="10">
			<el-col :span="16">
				<checkGroups :data="list" v-model="checked"></checkGroups>
			</el-col>
			<el-col :span="8">
				<draggableList v-model="checked"></draggableList>
			</el-col>
		</el-row>
		<div class="customColumnModal_footer">
			<el-button @click="cancel">取消</el-button>
			<el-button type="primary" @click="submit">应用</el-button>
		</div>
	</Modal>
</template>
<script>
import Modal from '@/components/iglobalwin/formComponents/modal/modal.vue';
import draggableList from './draggable-list.vue';
import checkGroups from './check-groups.vue';

export default {
	props: {
		visible: {
			type: Boolean,
			default: false,
		},
		list: {
			type: Array,
			default: function () {
				return [];
			},
		},
		customChecked: {
			type: Array,
			default: function () {
				return [];
			},
		},
		type: {
			type: String,
			default: '',
		},
	},
	data() {
		return {
			checked: [],
		};
	},
	components: {
		Modal,
		checkGroups,
		draggableList,
	},

	watch: {
		customChecked: {
			handler(val) {
				// this.checked = this.filterColumnsSync(val);
				this.checked = val;
			},
			deep: true,
			// immediate: true
		},
	},
	methods: {
		// filterColumnsSync(res) {
		// 	console.log('res',res)
		// 	let checked = [];
		// 	res.forEach(item => {
		// 		// 位置固定带锁的数据 或者 check为true的数据
		// 		if(item.parentCode === 'fixedPosition' || item.check) {
		// 			checked.push(item);
		// 		}
		// 	})
			
		// 	return checked;
		// },
		// 应用
		async submit() {
			this.$emit('getColumn', this.checked);
		},
		// 取消
		cancel() {
			this.$emit('update:visible', false);
			this.checked = this.customChecked;
		},
	}
};
</script>
<style lang="scss">
.customColumnModal{
	.customColumnModal_footer{
		line-height: 32px;
		padding-top: 18px;
		text-align: right;
	}
}
</style>
